import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentAccountsService {

  constructor(private readonly http: HttpClient) { }


  createNewPaymentaccount(payload: any) {
    let url = environment.BASE_URL + '/v1/account';
    return this.http.post(url, payload);
  }

  editPaymentAccount(id: string, payload:any) {
    let url = environment.BASE_URL + `/v1/account/${id}`;
    return this.http.put(url, payload);
  }

  getCompanyPaymentAccount(payload: any) {
    let url = environment.BASE_URL + '/v1/account';
    return this.http.get(url, { params: payload })
  }

  getPaymentAccountList(params: any) {
    let url = environment.BASE_URL + '/v1/account/payments-list';
    return this.http.get(url, { params: params })
  }

  getAccountsHighlights() {
    let url = environment.BASE_URL + '/v1/account/count';
    return this.http.get(url)
  }
}
